// extracted by mini-css-extract-plugin
export default {"icon":"WithdrawalLimitToastMessage_icon--SzF","content":"WithdrawalLimitToastMessage_content--bNi","button":"WithdrawalLimitToastMessage_button--FZJ"};